var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20.225,
    width: 28.6025,
    height: 28.6025,
    transform: "rotate(-45 0 20.225)",
    fill: "#FF2788"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.70996,
    y: 9.40546,
    width: 28.6025,
    height: 28.6025,
    transform: "rotate(-15 2.70996 9.40546)",
    fill: "#39ACFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8193,
    y: 2.70974,
    width: 28.6025,
    height: 28.6025,
    transform: "rotate(15 10.8193 2.70974)",
    fill: "#13FFDA"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.d0b4aa3c5625e8595631e6c7a7cb40dd.svg";
export { ForwardRef as ReactComponent };